import "./Toggle.less";
// ---------------------------------------------------------------------------------------------------
export interface ToggleProps {
    key: string | number;
    disabled?: boolean;
    toggled?: boolean;
    defaultToggled?: boolean;
    onToggle: (isChecked: boolean) => void;
    style?: React.CSSProperties;
    label?: string;
}
// ---------------------------------------------------------------------------------------------------
export default function Toggle(props: ToggleProps) {
    return <label
        className="yodiwo-toggle"
        key={props.key}
        style={props.style}>
        <span className="toggle-label">{props.label}</span>
        <input type="checkbox"
            disabled={props.disabled ?? false}
            checked={props.toggled}
            defaultChecked={props.defaultToggled}
            onChange={(event) => props.onToggle(event.target.checked)} />
        <span className="switcher"></span>
    </label>
}
// ---------------------------------------------------------------------------------------------------